export class ErrorFetch extends Error {
  data: unknown;
  status: number;
  statusText: string;

  constructor(status: number, statusText: string, data: unknown) {
    super(statusText);
    this.name = 'ErrorFetch';
    this.data = data;
    this.status = status;
    this.statusText = statusText;
  }

  /** Returns the `error` string from the response body, or `null` if absent. */
  getMessage(): string | null {
    if (
      this.data !== null &&
      typeof this.data === 'object' &&
      'error' in this.data
    ) {
      const { error } = this.data as Record<string, unknown>;
      if (typeof error === 'string') {
        return error;
      }
    }
    return null;
  }
}
